import { createSelector, createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";
import { produce } from "immer";

import { RequirementToast, successAddToast } from "@components/common/Toast";

const initialState = {
    workflowData: [],
    nextPreviousStep: "next",
};

export const workFlowDataSlice = createSlice({
    name: "workFlowDataSlice",
    initialState,
    reducers: {
        setWorkflowData: (state, action) => {
            state.workflowData = action.payload;
        },
        removeLastWorkflow: (state, { payload }) => {
            state.workflowData = produce(state.workflowData, (draftState) => {
                if (draftState.length > 0) {
                    draftState.splice(draftState.length - 1, 1);

                    if (
                        !payload.isModif ||
                        (payload.isModif && payload.isCancelEditProduct)
                    ) {
                        draftState[draftState.length - 1].workflow[
                            draftState[draftState.length - 1].index
                        ].NbrOfChoices =
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].NbrOfChoices - 1;

                        if (
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].NbrOfChoices === 0
                        ) {
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].selectedChoicesWithspecialPrice = 0;
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].selectedChoicesWithStepPrice = 0;
                        } else if (
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].NbrOfChoices >
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].nbrOfChoicesWithspecialPrice
                        ) {
                            if (
                                draftState[draftState.length - 1].workflow[
                                    draftState[draftState.length - 1].index
                                ].selectedChoicesWithStepPrice > 0
                            )
                                draftState[draftState.length - 1].workflow[
                                    draftState[draftState.length - 1].index
                                ].selectedChoicesWithStepPrice =
                                    draftState[draftState.length - 1].workflow[
                                        draftState[draftState.length - 1].index
                                    ].selectedChoicesWithStepPrice - 1;
                        } else {
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].selectedChoicesWithspecialPrice =
                                draftState[draftState.length - 1].workflow[
                                    draftState[draftState.length - 1].index
                                ].selectedChoicesWithspecialPrice - 1;
                        }
                    }
                }
            });
        },
        //@typescript-eslint/no-unused-vars
        setNextWorkflowStep: (state) => {
            state.workflowData[state.workflowData.length - 1].index += 1;
            state.nextPreviousStep = "next";
        },
        setPreviousWorkflowStep: (state) => {
            state.workflowData[state.workflowData.length - 1].index -= 1;
            state.nextPreviousStep = "prev";
        },
        steWorkflowStepIndex: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].index = payload;
            state.nextPreviousStep = "next";
        },
        steWorkflowStep: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].index = payload;
        },
        toggleBasicCompositionitem: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].Items[payload].basicCompositionActive =
                !state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].Items[payload].basicCompositionActive;
            if (
                !state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].Items[payload].basicCompositionActive
            ) {
                RequirementToast(t("Deleted product"));
            } else {
                successAddToast(t("Product added"));
            }
        },
        addWorkflowStepChoice: (state, { payload }) => {
            const {
                NbrOfChoices,
                selectedChoicesWithStepPrice,
                selectedChoicesWithspecialPrice,
                haveWorkflow,
                menuOnModification,
                isAutoPermutation,
            } = payload;
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].NbrOfChoices = NbrOfChoices;
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithStepPrice = selectedChoicesWithStepPrice;
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithspecialPrice = selectedChoicesWithspecialPrice;

            if (
                state.workflowData[state.workflowData.length - 1].index <
                    state.workflowData[state.workflowData.length - 1].step &&
                state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].maxNbrOfChoices === NbrOfChoices &&
                !haveWorkflow &&
                state.workflowData[state.workflowData.length - 1].workflow[
                    state.workflowData[state.workflowData.length - 1].index
                ].haveComment === false &&
                !menuOnModification
            ) {
                state.workflowData[state.workflowData.length - 1].index += 1;
                state.nextPreviousStep = "next";
            }

            !haveWorkflow &&
                state.workflowData[state.workflowData.length - 1].index <
                    state.workflowData[state.workflowData.length - 1].step &&
                !isAutoPermutation &&
                successAddToast(t("Product added"));
        },
        minusNbrChoiceOfCurrentStep: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].NbrOfChoices -= 1;

            const {
                selectedChoicesWithspecialPrice = 0,
                selectedChoicesWithStepPrice = 0,
            } = payload || {};
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithStepPrice = selectedChoicesWithStepPrice;

            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].selectedChoicesWithspecialPrice = selectedChoicesWithspecialPrice;
            RequirementToast(t("Deleted product"));
        },
        goToPreviousWorkflow: (state) => {
            state.workflowData = produce(state.workflowData, (draftState) => {
                if (draftState.length > 0) {
                    draftState.splice(draftState.length - 1, 1);
                    if (
                        draftState[draftState.length - 1].step >
                            draftState[draftState.length - 1].index &&
                        !draftState[draftState.length - 1].workflow[
                            draftState[draftState.length - 1].index
                        ].haveComment &&
                        draftState[draftState.length - 1].workflow[
                            draftState[draftState.length - 1].index
                        ].NbrOfChoices ===
                            draftState[draftState.length - 1].workflow[
                                draftState[draftState.length - 1].index
                            ].maxNbrOfChoices
                    ) {
                        draftState[draftState.length - 1].index += 1;
                    }
                }
            });
        },
        resetNbrOfChoice: (state) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].NbrOfChoices = 0;
        },
        intializeItemSelectedBasicComp: (state, { payload }) => {
            if (!payload.product.haveBasicComposition) return;
            const items = state.workflowData[
                state.workflowData.length - 1
            ].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].Items.map((item) =>
                item.iuud === payload.product.iuud
                    ? { ...item, selectedBasicComposition: [] }
                    : { ...item }
            );

            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].Items = items;
        },
        setSteptag: (state, { payload }) => {
            state.workflowData[state.workflowData.length - 1].workflow[
                state.workflowData[state.workflowData.length - 1].index
            ].stepTags = payload;
        },
    },
});

// Shared stable empty result so the "no tags" case never produces a fresh
// array reference (which would force subscribed components to re-render).
const EMPTY_STEP_TAGS = Object.freeze([]);

// Raw, referentially-stable input selectors. The derivation lives in the
// createSelector OUTPUT functions below — NOT here — so memoization actually
// holds. (Doing the .filter() in the input selector returns a new array every
// call, defeating createSelector and re-rendering every subscriber on every
// dispatch.)
const selectWorkflowData = (state) => state.workFlowDataSlice.workflowData;
const selectOrderTags = (state) => state.orderSlice.tags;

const getCurrentStepTagsData = (workflowData) => {
    const last = workflowData?.at(-1);
    const step = last?.workflow?.[last.index];
    return step?.stepTags ?? [];
};

export const memoizedGetStepTags = createSelector(
    [selectWorkflowData, selectOrderTags],
    (workflowData, orderTags) => {
        const stepTagsData = getCurrentStepTagsData(workflowData);
        if (stepTagsData.length === 0) return EMPTY_STEP_TAGS;

        return typeof stepTagsData[0] === "string"
            ? orderTags.filter(
                  (tag) => stepTagsData.includes(tag.id) && tag.isVisible
              )
            : stepTagsData.filter((tag) => tag.isVisible);
    }
);

export const memoizedGetActiveStepTags = createSelector(
    [selectWorkflowData],
    (workflowData) => {
        const stepTagsData = getCurrentStepTagsData(workflowData);
        const activeStepTags = stepTagsData.filter((tag) => tag.active);
        return activeStepTags.length === 0 ? EMPTY_STEP_TAGS : activeStepTags;
    }
);

export const {
    setWorkflowData,
    setNextWorkflowStep,
    setPreviousWorkflowStep,
    steWorkflowStepIndex,
    toggleBasicCompositionitem,
    addWorkflowStepChoice,
    removeLastWorkflow,
    minusNbrChoiceOfCurrentStep,
    goToPreviousWorkflow,
    resetNbrOfChoice,
    intializeItemSelectedBasicComp,
    setSteptag,
} = workFlowDataSlice.actions;

export default workFlowDataSlice.reducer;
